/**
 * @file use-navigation.js
 * @description Hook para navegação com React Router DOM v6 (CRA)
 */

import { useNavigate } from "react-router-dom"

/**
 * Hook para navegação
 * @returns {Object} Funções de navegação
 */
export function useNavigation() {
  const navigate = useNavigate()

  /**
   * Navega para uma rota com loading
   * @param {string} url - URL para navegar
   * @param {string} message - Mensagem de loading
   */
  const navigateWithLoading = (url, message = "Carregando informações...", options = {}) => {
    // Em CRA, apenas navega (loading pode ser gerenciado externamente)
    navigate(url, { state: { loadingMessage: message }, ...options })
  }

  /**
   * Substitui a rota atual com loading
   * @param {string} url - URL para navegar
   * @param {string} message - Mensagem de loading
   */
  const replaceWithLoading = (url, message = "Carregando informações...", options = {}) => {
    navigate(url, { replace: true, state: { loadingMessage: message }, ...options })
  }

  /**
   * Navega para uma rota
   * @param {string} url - URL para navegar
   * @param {string} message - Mensagem de loading
   */
  const navigateTo = (url, message = "Carregando informações...", options = {}) => {
    navigate(url, { state: { loadingMessage: message }, ...options })
  }

  return {
    navigateWithLoading,
    replaceWithLoading,
    navigate: navigateTo,
    showLoading: () => {},
    hideLoading: () => {},
  }
}
